import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { ProfileContainer } from '@/features/users/components/User/UserProfileDataEntry'

export const Profile = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'personal_data'} />

      <ProfileContainer />
    </>
  )
}
